(function () {
    'use strict';

    function noop() { }
    function run(fn) {
        return fn();
    }
    function blank_object() {
        return Object.create(null);
    }
    function run_all(fns) {
        fns.forEach(run);
    }
    function is_function(thing) {
        return typeof thing === 'function';
    }
    function safe_not_equal(a, b) {
        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
    }
    function is_empty(obj) {
        return Object.keys(obj).length === 0;
    }
    function append(target, node) {
        target.appendChild(node);
    }
    function append_styles(target, style_sheet_id, styles) {
        const append_styles_to = get_root_for_style(target);
        if (!append_styles_to.getElementById(style_sheet_id)) {
            const style = element('style');
            style.id = style_sheet_id;
            style.textContent = styles;
            append_stylesheet(append_styles_to, style);
        }
    }
    function get_root_for_style(node) {
        if (!node)
            return document;
        const root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
        if (root && root.host) {
            return root;
        }
        return node.ownerDocument;
    }
    function append_stylesheet(node, style) {
        append(node.head || node, style);
    }
    function insert(target, node, anchor) {
        target.insertBefore(node, anchor || null);
    }
    function detach(node) {
        node.parentNode.removeChild(node);
    }
    function element(name) {
        return document.createElement(name);
    }
    function text(data) {
        return document.createTextNode(data);
    }
    function space() {
        return text(' ');
    }
    function listen(node, event, handler, options) {
        node.addEventListener(event, handler, options);
        return () => node.removeEventListener(event, handler, options);
    }
    function attr(node, attribute, value) {
        if (value == null)
            node.removeAttribute(attribute);
        else if (node.getAttribute(attribute) !== value)
            node.setAttribute(attribute, value);
    }
    function to_number(value) {
        return value === '' ? null : +value;
    }
    function children(element) {
        return Array.from(element.childNodes);
    }
    function set_input_value(input, value) {
        input.value = value == null ? '' : value;
    }

    let current_component;
    function set_current_component(component) {
        current_component = component;
    }

    const dirty_components = [];
    const binding_callbacks = [];
    const render_callbacks = [];
    const flush_callbacks = [];
    const resolved_promise = Promise.resolve();
    let update_scheduled = false;
    function schedule_update() {
        if (!update_scheduled) {
            update_scheduled = true;
            resolved_promise.then(flush);
        }
    }
    function add_render_callback(fn) {
        render_callbacks.push(fn);
    }
    // flush() calls callbacks in this order:
    // 1. All beforeUpdate callbacks, in order: parents before children
    // 2. All bind:this callbacks, in reverse order: children before parents.
    // 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
    //    for afterUpdates called during the initial onMount, which are called in
    //    reverse order: children before parents.
    // Since callbacks might update component values, which could trigger another
    // call to flush(), the following steps guard against this:
    // 1. During beforeUpdate, any updated components will be added to the
    //    dirty_components array and will cause a reentrant call to flush(). Because
    //    the flush index is kept outside the function, the reentrant call will pick
    //    up where the earlier call left off and go through all dirty components. The
    //    current_component value is saved and restored so that the reentrant call will
    //    not interfere with the "parent" flush() call.
    // 2. bind:this callbacks cannot trigger new flush() calls.
    // 3. During afterUpdate, any updated components will NOT have their afterUpdate
    //    callback called a second time; the seen_callbacks set, outside the flush()
    //    function, guarantees this behavior.
    const seen_callbacks = new Set();
    let flushidx = 0; // Do *not* move this inside the flush() function
    function flush() {
        const saved_component = current_component;
        do {
            // first, call beforeUpdate functions
            // and update components
            while (flushidx < dirty_components.length) {
                const component = dirty_components[flushidx];
                flushidx++;
                set_current_component(component);
                update(component.$$);
            }
            set_current_component(null);
            dirty_components.length = 0;
            flushidx = 0;
            while (binding_callbacks.length)
                binding_callbacks.pop()();
            // then, once components are updated, call
            // afterUpdate functions. This may cause
            // subsequent updates...
            for (let i = 0; i < render_callbacks.length; i += 1) {
                const callback = render_callbacks[i];
                if (!seen_callbacks.has(callback)) {
                    // ...so guard against infinite loops
                    seen_callbacks.add(callback);
                    callback();
                }
            }
            render_callbacks.length = 0;
        } while (dirty_components.length);
        while (flush_callbacks.length) {
            flush_callbacks.pop()();
        }
        update_scheduled = false;
        seen_callbacks.clear();
        set_current_component(saved_component);
    }
    function update($$) {
        if ($$.fragment !== null) {
            $$.update();
            run_all($$.before_update);
            const dirty = $$.dirty;
            $$.dirty = [-1];
            $$.fragment && $$.fragment.p($$.ctx, dirty);
            $$.after_update.forEach(add_render_callback);
        }
    }
    const outroing = new Set();
    function transition_in(block, local) {
        if (block && block.i) {
            outroing.delete(block);
            block.i(local);
        }
    }
    function mount_component(component, target, anchor, customElement) {
        const { fragment, on_mount, on_destroy, after_update } = component.$$;
        fragment && fragment.m(target, anchor);
        if (!customElement) {
            // onMount happens before the initial afterUpdate
            add_render_callback(() => {
                const new_on_destroy = on_mount.map(run).filter(is_function);
                if (on_destroy) {
                    on_destroy.push(...new_on_destroy);
                }
                else {
                    // Edge case - component was destroyed immediately,
                    // most likely as a result of a binding initialising
                    run_all(new_on_destroy);
                }
                component.$$.on_mount = [];
            });
        }
        after_update.forEach(add_render_callback);
    }
    function destroy_component(component, detaching) {
        const $$ = component.$$;
        if ($$.fragment !== null) {
            run_all($$.on_destroy);
            $$.fragment && $$.fragment.d(detaching);
            // TODO null out other refs, including component.$$ (but need to
            // preserve final state?)
            $$.on_destroy = $$.fragment = null;
            $$.ctx = [];
        }
    }
    function make_dirty(component, i) {
        if (component.$$.dirty[0] === -1) {
            dirty_components.push(component);
            schedule_update();
            component.$$.dirty.fill(0);
        }
        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
    }
    function init(component, options, instance, create_fragment, not_equal, props, append_styles, dirty = [-1]) {
        const parent_component = current_component;
        set_current_component(component);
        const $$ = component.$$ = {
            fragment: null,
            ctx: null,
            // state
            props,
            update: noop,
            not_equal,
            bound: blank_object(),
            // lifecycle
            on_mount: [],
            on_destroy: [],
            on_disconnect: [],
            before_update: [],
            after_update: [],
            context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
            // everything else
            callbacks: blank_object(),
            dirty,
            skip_bound: false,
            root: options.target || parent_component.$$.root
        };
        append_styles && append_styles($$.root);
        let ready = false;
        $$.ctx = instance
            ? instance(component, options.props || {}, (i, ret, ...rest) => {
                const value = rest.length ? rest[0] : ret;
                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                    if (!$$.skip_bound && $$.bound[i])
                        $$.bound[i](value);
                    if (ready)
                        make_dirty(component, i);
                }
                return ret;
            })
            : [];
        $$.update();
        ready = true;
        run_all($$.before_update);
        // `false` as a special case of no DOM component
        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
        if (options.target) {
            if (options.hydrate) {
                const nodes = children(options.target);
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.l(nodes);
                nodes.forEach(detach);
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.c();
            }
            if (options.intro)
                transition_in(component.$$.fragment);
            mount_component(component, options.target, options.anchor, options.customElement);
            flush();
        }
        set_current_component(parent_component);
    }
    /**
     * Base class for Svelte components. Used when dev=false.
     */
    class SvelteComponent {
        $destroy() {
            destroy_component(this, 1);
            this.$destroy = noop;
        }
        $on(type, callback) {
            const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
            callbacks.push(callback);
            return () => {
                const index = callbacks.indexOf(callback);
                if (index !== -1)
                    callbacks.splice(index, 1);
            };
        }
        $set($$props) {
            if (this.$$set && !is_empty($$props)) {
                this.$$.skip_bound = true;
                this.$$set($$props);
                this.$$.skip_bound = false;
            }
        }
    }

    /* Embed.svelte generated by Svelte v3.46.4 */

    function add_css(target) {
    	append_styles(target, "svelte-rn3dkd", "label.svelte-rn3dkd{display:block;text:align-center;-webkit-appearance:none}span.svelte-rn3dkd{margin-top:0.8rem}#calc.svelte-rn3dkd{text-align:initial}");
    }

    function create_fragment(ctx) {
    	let h2;
    	let t1;
    	let div4;
    	let div0;
    	let label0;
    	let input0;
    	let t2;
    	let input1;
    	let t3;
    	let span0;
    	let t5;
    	let div1;
    	let label1;
    	let input2;
    	let t6;
    	let input3;
    	let t7;
    	let span1;
    	let t9;
    	let div2;
    	let label2;
    	let input4;
    	let t10;
    	let input5;
    	let t11;
    	let span2;
    	let t13;
    	let div3;
    	let label3;
    	let input6;
    	let t14;
    	let input7;
    	let t15;
    	let span3;
    	let mounted;
    	let dispose;

    	return {
    		c() {
    			h2 = element("h2");
    			h2.textContent = "Lighting Calculator";
    			t1 = space();
    			div4 = element("div");
    			div0 = element("div");
    			label0 = element("label");
    			input0 = element("input");
    			t2 = space();
    			input1 = element("input");
    			t3 = space();
    			span0 = element("span");
    			span0.textContent = "Distance (cm)";
    			t5 = space();
    			div1 = element("div");
    			label1 = element("label");
    			input2 = element("input");
    			t6 = space();
    			input3 = element("input");
    			t7 = space();
    			span1 = element("span");
    			span1.textContent = "PPFD";
    			t9 = space();
    			div2 = element("div");
    			label2 = element("label");
    			input4 = element("input");
    			t10 = space();
    			input5 = element("input");
    			t11 = space();
    			span2 = element("span");
    			span2.textContent = "Hours on per day";
    			t13 = space();
    			div3 = element("div");
    			label3 = element("label");
    			input6 = element("input");
    			t14 = space();
    			input7 = element("input");
    			t15 = space();
    			span3 = element("span");
    			span3.textContent = "DLI";
    			attr(input0, "class", "col-1-3");
    			attr(input0, "type", "number");
    			attr(input0, "min", "1");
    			attr(input0, "max", "30");
    			attr(input1, "class", "col-1-3 why");
    			attr(input1, "type", "range");
    			attr(input1, "min", "1");
    			attr(input1, "max", "30");
    			attr(span0, "class", "col-1-3 svelte-rn3dkd");
    			attr(label0, "class", "svelte-rn3dkd");
    			attr(div0, "class", "row");
    			attr(input2, "class", "col-1-3");
    			attr(input2, "type", "number");
    			attr(input2, "min", "30");
    			attr(input2, "max", "519");
    			attr(input3, "class", "col-1-3 why");
    			attr(input3, "type", "range");
    			attr(input3, "min", "30");
    			attr(input3, "max", "519");
    			attr(span1, "class", "col-1-3 svelte-rn3dkd");
    			attr(label1, "class", "svelte-rn3dkd");
    			attr(div1, "class", "row");
    			attr(input4, "class", "col-1-3");
    			attr(input4, "type", "number");
    			attr(input4, "min", "1");
    			attr(input4, "max", "16");
    			attr(input5, "class", "col-1-3 why");
    			attr(input5, "type", "range");
    			attr(input5, "min", "1");
    			attr(input5, "max", "16");
    			attr(span2, "class", "col-1-3 svelte-rn3dkd");
    			attr(label2, "class", "svelte-rn3dkd");
    			attr(div2, "class", "row");
    			attr(input6, "class", "col-1-3");
    			attr(input6, "type", "number");
    			attr(input6, "min", "1");
    			attr(input6, "max", "30");
    			attr(input7, "class", "col-1-3 why padding-left-2rem");
    			attr(input7, "type", "range");
    			attr(input7, "min", "1");
    			attr(input7, "max", "30");
    			attr(span3, "class", "col-1-3 svelte-rn3dkd");
    			attr(label3, "class", "svelte-rn3dkd");
    			attr(div3, "class", "row");
    			attr(div4, "id", "calc");
    			attr(div4, "class", "svelte-rn3dkd");
    		},
    		m(target, anchor) {
    			insert(target, h2, anchor);
    			insert(target, t1, anchor);
    			insert(target, div4, anchor);
    			append(div4, div0);
    			append(div0, label0);
    			append(label0, input0);
    			set_input_value(input0, /*distanceCm*/ ctx[0]);
    			append(label0, t2);
    			append(label0, input1);
    			set_input_value(input1, /*distanceCm*/ ctx[0]);
    			append(label0, t3);
    			append(label0, span0);
    			append(div4, t5);
    			append(div4, div1);
    			append(div1, label1);
    			append(label1, input2);
    			set_input_value(input2, /*ppfd*/ ctx[1]);
    			append(label1, t6);
    			append(label1, input3);
    			set_input_value(input3, /*ppfd*/ ctx[1]);
    			append(label1, t7);
    			append(label1, span1);
    			append(div4, t9);
    			append(div4, div2);
    			append(div2, label2);
    			append(label2, input4);
    			set_input_value(input4, /*hours*/ ctx[2]);
    			append(label2, t10);
    			append(label2, input5);
    			set_input_value(input5, /*hours*/ ctx[2]);
    			append(label2, t11);
    			append(label2, span2);
    			append(div4, t13);
    			append(div4, div3);
    			append(div3, label3);
    			append(label3, input6);
    			set_input_value(input6, /*dli*/ ctx[3]);
    			append(label3, t14);
    			append(label3, input7);
    			set_input_value(input7, /*dli*/ ctx[3]);
    			append(label3, t15);
    			append(label3, span3);

    			if (!mounted) {
    				dispose = [
    					listen(input0, "input", /*input0_input_handler*/ ctx[8]),
    					listen(input0, "input", /*changedDistance*/ ctx[4]),
    					listen(input1, "change", /*input1_change_input_handler*/ ctx[9]),
    					listen(input1, "input", /*input1_change_input_handler*/ ctx[9]),
    					listen(input1, "input", /*changedDistance*/ ctx[4]),
    					listen(input2, "input", /*input2_input_handler*/ ctx[10]),
    					listen(input2, "input", /*changedPpfd*/ ctx[5]),
    					listen(input3, "change", /*input3_change_input_handler*/ ctx[11]),
    					listen(input3, "input", /*input3_change_input_handler*/ ctx[11]),
    					listen(input3, "input", /*changedPpfd*/ ctx[5]),
    					listen(input4, "input", /*input4_input_handler*/ ctx[12]),
    					listen(input4, "input", /*changedHoursPerDay*/ ctx[6]),
    					listen(input5, "change", /*input5_change_input_handler*/ ctx[13]),
    					listen(input5, "input", /*input5_change_input_handler*/ ctx[13]),
    					listen(input5, "input", /*changedHoursPerDay*/ ctx[6]),
    					listen(input6, "input", /*input6_input_handler*/ ctx[14]),
    					listen(input6, "input", /*changedDli*/ ctx[7]),
    					listen(input7, "change", /*input7_change_input_handler*/ ctx[15]),
    					listen(input7, "input", /*input7_change_input_handler*/ ctx[15]),
    					listen(input7, "input", /*changedDli*/ ctx[7])
    				];

    				mounted = true;
    			}
    		},
    		p(ctx, [dirty]) {
    			if (dirty & /*distanceCm*/ 1 && to_number(input0.value) !== /*distanceCm*/ ctx[0]) {
    				set_input_value(input0, /*distanceCm*/ ctx[0]);
    			}

    			if (dirty & /*distanceCm*/ 1) {
    				set_input_value(input1, /*distanceCm*/ ctx[0]);
    			}

    			if (dirty & /*ppfd*/ 2 && to_number(input2.value) !== /*ppfd*/ ctx[1]) {
    				set_input_value(input2, /*ppfd*/ ctx[1]);
    			}

    			if (dirty & /*ppfd*/ 2) {
    				set_input_value(input3, /*ppfd*/ ctx[1]);
    			}

    			if (dirty & /*hours*/ 4 && to_number(input4.value) !== /*hours*/ ctx[2]) {
    				set_input_value(input4, /*hours*/ ctx[2]);
    			}

    			if (dirty & /*hours*/ 4) {
    				set_input_value(input5, /*hours*/ ctx[2]);
    			}

    			if (dirty & /*dli*/ 8 && to_number(input6.value) !== /*dli*/ ctx[3]) {
    				set_input_value(input6, /*dli*/ ctx[3]);
    			}

    			if (dirty & /*dli*/ 8) {
    				set_input_value(input7, /*dli*/ ctx[3]);
    			}
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(h2);
    			if (detaching) detach(t1);
    			if (detaching) detach(div4);
    			mounted = false;
    			run_all(dispose);
    		}
    	};
    }

    let Par = 10;

    function instance($$self, $$props, $$invalidate) {
    	let distanceCm = 10;
    	let ppfd = 318;
    	let hours = 12;
    	let dli = 13.7;
    	let EmissionAngle = Math.PI / 4;

    	function changedDistance() {
    		let radius = distanceCm / 100 * Math.tan(EmissionAngle);
    		let area = Math.PI * radius ** 2;
    		$$invalidate(1, ppfd = Math.round(Par / area));
    		$$invalidate(3, dli = Math.round(ppfd * 3600 / 1000000 * hours * 10) / 10);
    	}

    	function changedPpfd() {
    		let area = Par / ppfd;
    		let radius = Math.sqrt(area / Math.PI);
    		let distanceCmRaw = radius / Math.tan(EmissionAngle) * 100;
    		$$invalidate(0, distanceCm = Math.round(distanceCmRaw * 10) / 10);
    		$$invalidate(3, dli = Math.round(ppfd * 3600 / 1000000 * hours * 10) / 10);
    	}

    	function changedHoursPerDay() {
    		$$invalidate(3, dli = Math.round(ppfd * 3600 / 1000000 * hours * 10) / 10);
    	}

    	function changedDli() {
    		$$invalidate(1, ppfd = Math.round(dli / 3600 * 1000000 / hours));
    		let area = Par / ppfd;
    		let radius = Math.sqrt(area / Math.PI);
    		let distanceCmRaw = radius / Math.tan(EmissionAngle) * 100;
    		$$invalidate(0, distanceCm = Math.round(distanceCmRaw * 10) / 10);
    	}

    	function input0_input_handler() {
    		distanceCm = to_number(this.value);
    		$$invalidate(0, distanceCm);
    	}

    	function input1_change_input_handler() {
    		distanceCm = to_number(this.value);
    		$$invalidate(0, distanceCm);
    	}

    	function input2_input_handler() {
    		ppfd = to_number(this.value);
    		$$invalidate(1, ppfd);
    	}

    	function input3_change_input_handler() {
    		ppfd = to_number(this.value);
    		$$invalidate(1, ppfd);
    	}

    	function input4_input_handler() {
    		hours = to_number(this.value);
    		$$invalidate(2, hours);
    	}

    	function input5_change_input_handler() {
    		hours = to_number(this.value);
    		$$invalidate(2, hours);
    	}

    	function input6_input_handler() {
    		dli = to_number(this.value);
    		$$invalidate(3, dli);
    	}

    	function input7_change_input_handler() {
    		dli = to_number(this.value);
    		$$invalidate(3, dli);
    	}

    	return [
    		distanceCm,
    		ppfd,
    		hours,
    		dli,
    		changedDistance,
    		changedPpfd,
    		changedHoursPerDay,
    		changedDli,
    		input0_input_handler,
    		input1_change_input_handler,
    		input2_input_handler,
    		input3_change_input_handler,
    		input4_input_handler,
    		input5_change_input_handler,
    		input6_input_handler,
    		input7_change_input_handler
    	];
    }

    class Embed extends SvelteComponent {
    	constructor(options) {
    		super();
    		init(this, options, instance, create_fragment, safe_not_equal, {}, add_css);
    	}
    }

    var div = document.createElement('DIV');
    var script = document.currentScript;
    script.parentNode.insertBefore(div, script);

    new Embed({
    	target: div,
    	props: { name: 'Svelte component' },
    });

})();
